<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="6"
        order-md="1"
        class="mb-4 mb-md-0 pt-4 pt-md-0"
      >
        <v-card
          class="mb-5 mt-3"
          rounded="sm"
        >
          <FilterCycleByStatus v-model="status_filter" />
          <CycleRow
            v-for="(cycle, key) in filteredCycles"
            :key="key"
            :cycle="cycle"
          />
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="6"
        sm="12"
        order-md="2"
      >
        <Graphic />
        <WeekCalendar v-show="!isMobile" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import WeekCalendar from "./WeekCalendar";
import { mapActions, mapGetters, mapMutations} from "vuex";
import CycleRow from './CycleRow.vue';
import Graphic from './Graphic.vue';
import FilterCycleByStatus from './FilterCycleByStatus.vue';

export default {
  components: {
    WeekCalendar,
    CycleRow,
    FilterCycleByStatus,
    Graphic
  },
  data(){
    return {
      status_filter: '',
    }
  },
  computed: {
    ...mapGetters(['current_cycle','selectedCycle','count_challenges','cycles','isLoadingCycles']),
    filteredCycles() {
      if(!this.status_filter){
        return this.cycles;
      }
      return this.cycles.filter(c=> c.status == this.status_filter)
    },
  },
  created() {
    if (!this.isLoadingCycles) {
      this.getCycles()
    }

    if(!this.selectedCycle){
      this.SET_CYCLE(this.current_cycle)
    }
    this.SHOW_WARNINGS();
  },
  methods:{
    ...mapMutations(['SHOW_WARNINGS','SET_CYCLE']),
    ...mapActions(['getCycles'])
  },
}
</script>